function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.178 21.312a9.074 9.074 0 01-6.457-2.675 9.072 9.072 0 01-2.676-6.459c0-2.438.95-4.732 2.676-6.457a9.063 9.063 0 016.457-2.676c2.44 0 4.733.948 6.458 2.676a9.069 9.069 0 012.676 6.457c0 2.44-.95 4.735-2.676 6.46a9.074 9.074 0 01-6.457 2.674zM30 27.847l-8.21-8.21a12.069 12.069 0 002.567-7.459c0-3.253-1.268-6.311-3.568-8.61A12.082 12.082 0 0012.179 0c-3.254 0-6.31 1.265-8.61 3.568A12.094 12.094 0 000 12.178c0 3.254 1.268 6.31 3.568 8.61a12.09 12.09 0 008.61 3.569 12.06 12.06 0 007.46-2.567L27.848 30 30 27.848z",
  fill: "currentColor"
})));